import React, { useState } from "react";
import { getWhatsAppQR } from "../../../services/user";
import Popup from "../../../components/Popup";

const WhatsAppSettings = ({ isOpen, onClose, staffUser }) => {
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const getQRCode = async (data) => {
    setIsLoading(true);
    setSuccess(null);
    setError(null);

    // call server api here
    try {
      const responseData = await getWhatsAppQR(staffUser);
      console.log("rsp", responseData);
      setSuccess(responseData);
    } catch (error) {
      setError(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Popup isOpen={isOpen} onClose={onClose} title="Connect WhatsApp" mdWidth="max-w-md">
      <div className="flex items-center justify-center text-center">
        {success && success.qr ? <img src={success.qr} alt="QR" style={{ border: "10px solid #FFF" }} /> : <></>}
        {isLoading ? <div className="pt-2 text-green-600">Loading...</div> : <></>}
      </div>
      <div className="flex items-center justify-center text-center">
        <button onClick={() => getQRCode()} type="button" className={`group relative mt-4 flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 ${isLoading ? "bg-gray-500 cursor-not-allowed" : "bg-indigo-600"}`}>
          Get QR Code
        </button>
      </div>

      <div className="pt-2 text-red-600">{error?.message}</div>
      <div className="pt-2 text-green-600">{success?.message}</div>
    </Popup>
  );
};

export default WhatsAppSettings;
